import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
import Examination_navbar from './Examination_navbar';
import "react-toastify/dist/ReactToastify.css";
import { Form, Spinner } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import config from "../../Config";
import ExamsDropDown from "../Shared/ExamsDropDown";

const OldResults = () => {
    const AccessKey = localStorage.getItem("AccessKey");
    const UserID = localStorage.getItem("ID");
    const MemberType = localStorage.getItem("MemberType");

    const [validated, setValidated] = useState(false);
    const [filterHierarchy, setFilterHierarchy] = useState([]);
    const [filtersLoading, setFiltersLoading] = useState(false);

    const [WingId, setWingId] = useState(0);
    const [ClassId, setClassId] = useState(0);
    const [SectionID, setSectionID] = useState(0);
    const [FirstExamID, setFirstExamID] = useState(0);
    const [SecondExamID, setSecondExamID] = useState(0);
    const [ThirdExamID, setThirdExamID] = useState(0);
    const [FourthExamID, setFourthExamID] = useState(0);
    const [PrintTotal, setPrintTotal] = useState("No");
    const [Group, setGroup] = useState("No");

    const printDisabled =
        filtersLoading ||
        FirstExamID === 0 ||
        WingId === 0 ||
        ClassId === 0;

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const getInt = (key) => {
            const raw = urlParams.get(key);
            if (raw === null || raw === "") return null;
            const parsed = parseInt(raw, 10);
            return Number.isNaN(parsed) ? null : parsed;
        };

        const firstExam = getInt("FirstExam");
        const secondExam = getInt("SecondExam");
        const thirdExam = getInt("ThirdExam");
        const fourthExam = getInt("FourthExam");
        const wingId = getInt("WingId");
        const classId = getInt("Class_ID") ?? getInt("ClassId");
        const sectionId = getInt("Section_Id") ?? getInt("SectionId");
        const printTotal = urlParams.get("PrintTotal");
        const group = urlParams.get("Group");

        if (firstExam !== null) {
            setFirstExamID(firstExam);
            if (firstExam > 0) setFiltersLoading(true);
        }
        if (secondExam !== null) setSecondExamID(secondExam);
        if (thirdExam !== null) setThirdExamID(thirdExam);
        if (fourthExam !== null) setFourthExamID(fourthExam);
        if (wingId !== null) setWingId(wingId);
        if (classId !== null) setClassId(classId);
        if (sectionId !== null) setSectionID(sectionId);
        if (printTotal === "Yes" || printTotal === "No") setPrintTotal(printTotal);
        if (group === "Yes" || group === "No") setGroup(group);
    }, []);

    useEffect(() => {
        const params = new URLSearchParams();
        params.set("FirstExam", String(FirstExamID));
        params.set("SecondExam", String(SecondExamID));
        params.set("ThirdExam", String(ThirdExamID));
        params.set("FourthExam", String(FourthExamID));
        params.set("WingId", String(WingId));
        params.set("Class_ID", String(ClassId));
        params.set("Section_Id", String(SectionID));
        params.set("PrintTotal", PrintTotal);
        params.set("Group", Group);

        const newUrl = `${window.location.pathname}?${params.toString()}`;
        window.history.replaceState(null, "", newUrl);
    }, [
        FirstExamID,
        SecondExamID,
        ThirdExamID,
        FourthExamID,
        WingId,
        ClassId,
        SectionID,
        PrintTotal,
        Group,
    ]);

    const selectedWing = filterHierarchy.find((w) => w.Wing_ID === WingId);
    const classOptions = selectedWing?.Classes || [];
    const selectedClass = classOptions.find((c) => c.Class_ID === ClassId);
    const sectionOptions = selectedClass?.Sections || [];

    const loadExamDataFilters = () => {
        if (FirstExamID <= 0) {
            setFilterHierarchy([]);
            setFiltersLoading(false);
            setWingId(0);
            setClassId(0);
            setSectionID(0);
            return;
        }

        setFiltersLoading(true);
        axios({
            method: "post",
            url: config.base_url + "Exam/GetExamDataFilterOptions",
            headers: { "Content-Type": "application/json" },
            data: {
                AccessKey,
                UserID,
                MemberType,
                FirstExamID,
                SecondExamID,
                ThirdExamID,
                FourthExamID,
            },
        })
            .then((response) => {
                if (response.data?.status_code === 1) {
                    setFilterHierarchy(response.data.FilterHierarchy || []);
                } else {
                    setFilterHierarchy([]);
                    toast.error(
                        response.data?.status_message || "Unable to load filters from exam data.",
                        { position: toast.POSITION.TOP_RIGHT }
                    );
                }
                setFiltersLoading(false);
            })
            .catch(() => {
                setFilterHierarchy([]);
                setFiltersLoading(false);
                toast.error("Network error loading exam filters.", {
                    position: toast.POSITION.TOP_RIGHT,
                });
            });
    };

    useEffect(() => {
        loadExamDataFilters();
    }, [FirstExamID, SecondExamID, ThirdExamID, FourthExamID]);

    const handlesetPrintTotalChange = (e) => {
        setPrintTotal(e.target.checked ? "Yes" : "No");
    };

    const handlesetGroupChange = (e) => {
        setGroup(e.target.checked ? "Yes" : "No");
    };

    const triggerFilterReload = () => {
        if (FirstExamID > 0) setFiltersLoading(true);
    };

    return (
        <>
            <Examination_navbar />
            <ToastContainer />
            <div className="page-head">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/Dashboard">Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="/ExaminationSystem/ExaminationDashboard">
                                            Examinations
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Print Old Results
                                    </li>
                                </ol>
                            </nav>
                            <div className="page-title">Print Old Results</div>
                            <p className="text-muted small mb-0">
                                Wing, class, and section lists come from historical exam data (tblExamData), not the current student session.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="page-content">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body p-md-4">
                                    <Form noValidate validated={validated}>
                                        <div className="row align-items-center">
                                            <div className="col-md-7">
                                                <div className="form-group mb-3">
                                                    <div className="row">
                                                        <label htmlFor="firstExamSelect" className="col-sm-5 col-form-label">
                                                            Select First Exam:
                                                        </label>
                                                        <div className="col-sm-7">
                                                            <select
                                                                id="firstExamSelect"
                                                                className="form-select"
                                                                required
                                                                value={FirstExamID}
                                                                onChange={(e) => {
                                                                    const v = parseInt(e.target.value || "0", 10);
                                                                    setFiltersLoading(v > 0);
                                                                    setFirstExamID(v);
                                                                    setWingId(0);
                                                                    setClassId(0);
                                                                    setSectionID(0);
                                                                }}
                                                            >
                                                                <option value="0">Please Select</option>
                                                                <ExamsDropDown />
                                                            </select>
                                                            <div className="form-text">
                                                                Main exam for master sheet printing.
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="form-group mb-3">
                                                    <div className="row">
                                                        <label htmlFor="secondExamSelect" className="col-sm-5 col-form-label">Select Second Exam:</label>
                                                        <div className="col-sm-7">
                                                            <select
                                                                id="secondExamSelect"
                                                                className="form-select"
                                                                value={SecondExamID}
                                                                onChange={(e) => {
                                                                    triggerFilterReload();
                                                                    setSecondExamID(parseInt(e.target.value || "0", 10));
                                                                }}
                                                            >
                                                                <option value="0">Please Select</option>
                                                                <ExamsDropDown />
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="form-group mb-3">
                                                    <div className="row">
                                                        <label htmlFor="thirdExamSelect" className="col-sm-5 col-form-label">Select Third Exam:</label>
                                                        <div className="col-sm-7">
                                                            <select
                                                                id="thirdExamSelect"
                                                                className="form-select"
                                                                value={ThirdExamID}
                                                                onChange={(e) => {
                                                                    triggerFilterReload();
                                                                    setThirdExamID(parseInt(e.target.value || "0", 10));
                                                                }}
                                                            >
                                                                <option value="0">Please Select</option>
                                                                <ExamsDropDown />
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="form-group mb-3">
                                                    <div className="row">
                                                        <label htmlFor="fourthExamSelect" className="col-sm-5 col-form-label">Select Fourth Exam:</label>
                                                        <div className="col-sm-7">
                                                            <select
                                                                id="fourthExamSelect"
                                                                className="form-select"
                                                                value={FourthExamID}
                                                                onChange={(e) => {
                                                                    triggerFilterReload();
                                                                    setFourthExamID(parseInt(e.target.value || "0", 10));
                                                                }}
                                                            >
                                                                <option value="0">Please Select</option>
                                                                <ExamsDropDown />
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                                {FirstExamID > 0 && filtersLoading && (
                                                    <div className="form-group mb-2">
                                                        <div className="d-flex align-items-center text-primary small">
                                                            <Spinner
                                                                animation="border"
                                                                size="sm"
                                                                role="status"
                                                                className="me-2"
                                                            />
                                                            <span>Loading wing, class, and section from exam data…</span>
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="form-group mb-3">
                                                    <div className="row align-items-center">
                                                        <label htmlFor="wingSelect" className="col-sm-5 col-form-label">Select Wing:</label>
                                                        <div className="col-sm-7">
                                                            <div className="d-flex align-items-center gap-2">
                                                                <select
                                                                    id="wingSelect"
                                                                    className="form-select"
                                                                    value={WingId}
                                                                    disabled={filtersLoading || FirstExamID === 0}
                                                                    onChange={(e) => {
                                                                        setWingId(parseInt(e.target.value || "0", 10));
                                                                        setClassId(0);
                                                                        setSectionID(0);
                                                                    }}
                                                                >
                                                                    {filtersLoading ? (
                                                                        <option value="0">Loading wings…</option>
                                                                    ) : (
                                                                        <>
                                                                            <option value="0">--- All ---</option>
                                                                            {filterHierarchy.map((w) => (
                                                                                <option key={w.Wing_ID} value={w.Wing_ID}>
                                                                                    {w.Wing_Name}
                                                                                </option>
                                                                            ))}
                                                                        </>
                                                                    )}
                                                                </select>
                                                                {filtersLoading && FirstExamID > 0 && (
                                                                    <Spinner animation="border" size="sm" role="status" />
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="form-group mb-3">
                                                    <div className="row align-items-center">
                                                        <label htmlFor="classSelect" className="col-sm-5 col-form-label">Select Class:</label>
                                                        <div className="col-sm-7">
                                                            <div className="d-flex align-items-center gap-2">
                                                                <select
                                                                    id="classSelect"
                                                                    className="form-select"
                                                                    value={ClassId}
                                                                    disabled={filtersLoading || WingId === 0 || FirstExamID === 0}
                                                                    onChange={(e) => {
                                                                        setClassId(parseInt(e.target.value || "0", 10));
                                                                        setSectionID(0);
                                                                    }}
                                                                >
                                                                    {filtersLoading ? (
                                                                        <option value="0">Loading classes…</option>
                                                                    ) : (
                                                                        <>
                                                                            <option value="0">Please Select</option>
                                                                            {classOptions.map((c) => (
                                                                                <option key={c.Class_ID} value={c.Class_ID}>
                                                                                    {c.Class_Name}
                                                                                </option>
                                                                            ))}
                                                                        </>
                                                                    )}
                                                                </select>
                                                                {filtersLoading && FirstExamID > 0 && (
                                                                    <Spinner animation="border" size="sm" role="status" />
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="form-group mb-3">
                                                    <div className="row align-items-center">
                                                        <label htmlFor="sectionSelect" className="col-sm-5 col-form-label">Select Section:</label>
                                                        <div className="col-sm-7">
                                                            <div className="d-flex align-items-center gap-2">
                                                                <select
                                                                    id="sectionSelect"
                                                                    className="form-select"
                                                                    value={SectionID}
                                                                    disabled={filtersLoading || ClassId === 0 || FirstExamID === 0}
                                                                    onChange={(e) => setSectionID(parseInt(e.target.value || "0", 10))}
                                                                >
                                                                    {filtersLoading ? (
                                                                        <option value="0">Loading sections…</option>
                                                                    ) : (
                                                                        <>
                                                                            <option value="0">Please Select</option>
                                                                            {sectionOptions.map((s) => (
                                                                                <option key={s.Section_ID} value={s.Section_ID}>
                                                                                    {s.Section_Name}
                                                                                </option>
                                                                            ))}
                                                                        </>
                                                                    )}
                                                                </select>
                                                                {filtersLoading && FirstExamID > 0 && (
                                                                    <Spinner animation="border" size="sm" role="status" />
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-4 offset-md-1">
                                                <div className="custom-button">
                                                    <div className="form-check mb-3">
                                                        <input className="form-check-input" type="checkbox" onChange={handlesetPrintTotalChange} checked={PrintTotal === "Yes"} id="PrintTotalCheck" />
                                                        <label htmlFor="PrintTotalCheck" className="form-check-label">
                                                            Print Totals on Master Sheet
                                                        </label>
                                                    </div>

                                                    <div className="form-check mb-3">
                                                        <input className="form-check-input" type="checkbox" onChange={handlesetGroupChange} checked={Group === "Yes"} id="groupTwoExamsCheckbox" />
                                                        <label htmlFor="groupTwoExamsCheckbox" className="form-check-label">
                                                            Group Two Exams
                                                        </label>
                                                    </div>

                                                    {filtersLoading && FirstExamID > 0 && (
                                                        <div className="d-flex align-items-center text-muted small mb-3">
                                                            <Spinner animation="border" size="sm" role="status" className="me-2" />
                                                            <span>Please wait — loading filters…</span>
                                                        </div>
                                                    )}

                                                    <div className="buttons">
                                                        <NavLink target="_blank"
                                                            to={`/ExaminationSystem/OldReportPrintExamDataSheet/?ID=${FirstExamID}&WingId=${WingId}&ClassId=${ClassId}&SectionId=${SectionID}&PrintTotal=${PrintTotal}`}
                                                            className={`button button-primary d-block mb-3 ${printDisabled ? 'disabled' : ''}`}>Print Data Sheets</NavLink>

                                                        <NavLink target="_blank"
                                                            to={`/ExaminationSystem/OldReportPrintExamDataSheetMultiple/?FirstExamID=${FirstExamID}&SecondExamID=${SecondExamID}&ThirdExamID=${ThirdExamID}&WingId=${WingId}&ClassId=${ClassId}&SectionId=${SectionID}&PrintTotal=${PrintTotal}&Group=${Group}`}
                                                            className={`button button-primary d-block mb-3 ${printDisabled || SecondExamID === 0 ? 'disabled' : ''}`}>Print Collective Data Sheets</NavLink>

                                                        <NavLink target="_blank"
                                                            to={`/ExaminationSystem/OldPrintResultCards/?FirstExamID=${FirstExamID}&SecondExamID=${SecondExamID}&ThirdExamID=${ThirdExamID}&FourthExamID=${FourthExamID}&WingId=${WingId}&ClassId=${ClassId}&SectionId=${SectionID}`}
                                                            className={`button button-primary w-100 d-block mb-3 ${printDisabled ? 'disabled' : ''}`}>Print Old Result Cards</NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default OldResults;
